import {
  DEFAULT_DESCRIPTION,
  DEFAULT_TITLE,
  normalizePath,
} from './siteConfig';

/**
 * Public URL → SEO metadata.
 * index: true  → marketing pages Google should rank
 * index: false → auth, shared, and utility pages (noindex)
 */
export const PUBLIC_PAGES = {
  '/': {
    title: DEFAULT_TITLE,
    heading: 'One workspace. Pay only for the modules you use.',
    description: DEFAULT_DESCRIPTION,
    index: true,
  },
  '/products': {
    title: 'flowdo products | Tasks, Snap Bill, Documents, and more',
    pageTitle: 'Products',
    heading: 'Choose the flowdo modules your team needs',
    description:
      'Explore flowdo modules: Tasks, Snap Bill, Documents, Projects, Credentials Vault, and Discussion Forum. Pick what you need and start free.',
    index: true,
  },
  '/products/task': {
    title: 'Task Management - flowdo',
    pageTitle: 'Tasks',
    heading: 'Manage yours and team tasks in one place',
    description:
      'Assign work, set reminders, and track progress with flowdo Tasks. Built for branches and departments. Start free, upgrade when you need more.',
    index: true,
  },
  '/products/projects': {
    title: 'Project Management - flowdo',
    pageTitle: 'Projects',
    heading: 'Event or Projects? Manage all in one place.',
    description:
      'Plan projects with owners, timelines, and stakeholder updates in flowdo. Keep tasks, files, and progress in one workspace instead of spreadsheets and chat.',
    index: true,
  },
  '/products/snap-bill': {
    title: 'Snap Bill - flowdo',
    pageTitle: 'Snap Bill',
    heading: 'Streamline your bill entries, LPO generation and SOA verification',
    description:
      'Photograph expense bills, extract the data with AI, and push it to your accounting system. Convert estimates to LPO and verify SOA in flowdo Snap Bill.',
    index: true,
  },
  '/products/documents': {
    title: 'Business Document Management - flowdo',
    pageTitle: 'Documents',
    heading: 'Centralized Storage with Sharing, Versioning and Reminder',
    description:
      'Store, share, and organize business files in flowdo Documents. Role-based access, version history, and reminders when documents expire.',
    index: true,
  },
  '/products/credentials-vault': {
    title: 'Credentials Vault - flowdo',
    pageTitle: 'Credentials Vault',
    heading: 'Don’t ever lose important passwords. 2-level secured storage.',
    description:
      'Store corporate and personal passwords and API keys in flowdo Credentials Vault. Role-based sharing and an audit trail of who viewed what.',
    index: true,
  },
  '/products/discussion-forum': {
    title: 'Discussion Forum - flowdo',
    pageTitle: 'Discussion Forum',
    heading: 'Keep record of all your major discussions and decisions.',
    description:
      'Replace scattered chats with topic-based discussions in flowdo. Keep files, replies, and decisions searchable in one place.',
    index: true,
  },
  '/pricing': {
    title: 'Pricing - flowdo',
    pageTitle: 'Pricing',
    heading: 'Simple module pricing. Start free.',
    description:
      'Pay only for the flowdo modules you use. Every module starts free. Plans from $1 per month — built for small and medium businesses.',
    index: true,
  },
  '/about-us': {
    title: 'About us - flowdo',
    heading: 'Built for teams that outgrew spreadsheets',
    description:
      'flowdo is modular business software for small and medium teams. Tasks, documents, AI bill capture, projects, a credentials vault, and a discussion forum — pay for what you use.',
    index: true,
  },
  '/contact-us': {
    title: 'Contact us - flowdo',
    heading: 'Talk to the flowdo team',
    description:
      'Contact the flowdo team about modules, pricing, or your workspace. We help SMEs run tasks, documents, billing, and more in one platform.',
    index: true,
  },
  '/privacy-policy': {
    title: 'Privacy Policy - flowdo',
    description: 'How flowdo collects, uses, and protects personal and business data.',
    index: true,
  },
  '/terms-and-conditions': {
    title: 'Terms & Conditions - flowdo',
    description: 'Terms of use for the flowdo platform, subscriptions, and related services.',
    index: true,
  },
  '/refund-cancellation-policy': {
    title: 'Refund & Cancellation Policy - flowdo',
    description: 'flowdo refund and cancellation terms for module subscriptions and related purchases.',
    index: true,
  },
  '/login': {
    title: 'Login - flowdo',
    description: 'Sign in to your flowdo workspace.',
    index: false,
  },
  '/register': {
    title: 'Register - flowdo',
    description: 'Create a flowdo workspace. Start free — no credit card required.',
    index: false,
  },
  '/forgot-password': {
    title: 'Forgot password - flowdo',
    description: 'Reset your flowdo account password.',
    index: false,
  },
  '/reset-password': {
    title: 'Reset password - flowdo',
    description: 'Choose a new password for your flowdo account.',
    index: false,
  },
  '/registration-subscription': {
    title: 'Choose a plan - flowdo',
    description: 'Select flowdo modules and complete registration.',
    index: false,
  },
  '/test-subscription': {
    title: 'Test subscription - flowdo',
    description: 'Internal subscription test page.',
    index: false,
  },
  '/shared': {
    title: 'Shared document - flowdo',
    description: 'View a document shared with you on flowdo.',
    index: false,
  },
  '/auth/module-session': {
    title: 'Opening module - flowdo',
    description: 'Completing your flowdo module session.',
    index: false,
  },
  '/module-logout': {
    title: 'Signed out - flowdo',
    description: 'You have been signed out of this flowdo module.',
    index: false,
  },
};

export function getPublicPageSeo(pathname) {
  const path = normalizePath(pathname);
  const page = PUBLIC_PAGES[path];
  if (!page) return null;
  return { path, ...page };
}

export function isPublicSeoPath(pathname) {
  return !!getPublicPageSeo(pathname);
}
